module.exports = __webpack_public_path__ + "img/ic_question-mark_active.5471827f.svg";